import { createContext } from "react";

const changeComponent = createContext({
  DivName: "",
});

export default changeComponent;